import threeFoursRootReducer from 'store/widgets/ThreeFours/reducers';

import { convertWidgetData } from './dataConverter';

export { default as ThreeFoursBanner } from './components/CatalogBanner';
export { default as ThreeFoursModal } from './components/AuthModal';

/**
 * inject in connectProvider widget as `threeFours` key
 */
export default [threeFoursRootReducer, convertWidgetData];
